// noinspection GraphQLUnresolvedReference

import { gql, GraphQLClient } from 'graphql-request'

import { AccessToken } from '../../../base/models/paramsModel'
import { MyGraphQlError } from '../../../base/services/GraphqlError'
import { SinTipoMonedaProps } from '../../../interfaces/sin.interface'

const query = gql`
  query SIN_MONEDAS {
    sinTipoMoneda {
      codigoClasificador
      descripcion
    }
  }
`

/**
 * Listamos las monedas para su homologación
 */
export const apiSinMonedaListado = async (): Promise<SinTipoMonedaProps[]> => {
  try {
    const client = new GraphQLClient(import.meta.env.ISI_API_URL)
    const token = localStorage.getItem(AccessToken)
    // Set a single header
    client.setHeader('authorization', `Bearer ${token}`)

    const data: any = await client.request(query)
    return data.sinTipoMoneda
  } catch (e: any) {
    throw new MyGraphQlError(e)
  }
}
